import { render } from "./ModalCurrency.vue?vue&type=template&id=0c8baf7c"
import script from "./ModalCurrency.vue?vue&type=script&lang=js"
export * from "./ModalCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__